// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3PW71","description":"PatientConsentPreview_description__30C5S"};